import { styled } from 'styled-components';
import { useScene } from '../../../hooks';
import { VisibilityToggle } from './VisibilityToggle';

export const Visibilitybar = () => {
  const scene = useScene();
  const isVisible = scene.selectedElementIDs.length > 0;

  return (
    <Container $isVisible={isVisible}>
      <FloatingItem>
        <VisibilityToggle />
      </FloatingItem>
      {/* <Item>
        <VisibilityToggle forState="doesAppDirExist" />
      </Item>
      <Separator /> */}
      <Item>
        <VisibilityToggle forState="isAppInstalled" />
      </Item>
      <Item>
        <VisibilityToggle
          forState="doesAppNeedRepair"
          defaultForState="isAppInstalled"
        />
      </Item>
      <Item>
        <VisibilityToggle
          forState="isAppUpdateAvailable"
          defaultForState="isAppInstalled"
        />
      </Item>
      <Separator />
      <Item>
        <VisibilityToggle forState="doesAppOngoingTaskExist" />
      </Item>
      <Item>
        <VisibilityToggle
          forState="doesAppOngoingInstallTaskExist"
          defaultForState="doesAppOngoingTaskExist"
        />
      </Item>
      <Item>
        <VisibilityToggle
          forState="doesAppOngoingUpdateTaskExist"
          defaultForState="doesAppOngoingTaskExist"
        />
      </Item>
      <Item>
        <VisibilityToggle
          forState="doesAppOngoingUninstallTaskExist"
          defaultForState="doesAppOngoingTaskExist"
        />
      </Item>
      <Item>
        <VisibilityToggle
          forState="doesAppOngoingRepairTaskExist"
          defaultForState="doesAppOngoingTaskExist"
        />
      </Item>
      {/* <Item>
        <VisibilityToggle
          forState="doesAppOngoingMoveTaskExist"
          defaultForState="doesAppOngoingTaskExist"
        />
      </Item> */}
      {/* <Separator />
      <Item>
        <VisibilityToggle forState="doesAppLastTaskFailed" />
      </Item> */}
    </Container>
  );
};

const Container = styled.div<{ $isVisible: boolean }>`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 2px;
  padding: 2px;

  display: flex;

  background-color: var(--panel-bg-color);
  border-radius: 10px;

  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  ${({ $isVisible }) => $isVisible && `opacity: 1; pointer-events: all`}
`;

const Item = styled.div`
  user-select: none;
  width: 45px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const FloatingItem = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  transform: translateX(calc(-100% - 2px));
  user-select: none;
  width: 45px;
  padding: 2px;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: var(--panel-bg-color);
  border-radius: 10px;
`;

const Separator = styled.div`
  width: 9px;
  display: flex;
  justify-content: center;
  align-items: center;

  opacity: 0.5;

  &::after {
    content: '';
    width: 1px;
  }
`;
